export default {
	account_menu_status_label: 'Status',
	user_online_dialog_custom_status_message: 'Hier können Sie einen benutzerdefinierten Status eingeben',
	user_online_status_picker_aria_label: 'Benutzerstatus auswählen',
	user_online_status_picker_current_aria_label: 'Aktueller Benutzerstatus: {status}',
};
